// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Countdown_countdown__2nT-g","countdownMessage":"Countdown_countdownMessage__PbCxJ","countdownNumber":"Countdown_countdownNumber__1cM4E"};